<div class="audience-start-container">
    <mat-toolbar class="grow-toolbar mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <button mat-icon-button (click)="toggleSidenav()" *ngIf="!isLargeScreen">
                <mat-icon>apps</mat-icon>
            </button>
            <div fxLayout="column" class="w-100-p" *ngIf="audience?.parent; else defaultAudienceTitle">
                <h5 class="parent-name pl-8">{{ audience.parent.name | audienceDisplayName }}</h5>
                <app-inline-rename [value]="audience.name" (update)="renameAudience($event)" *ngIf="!audience.isAutoGenerated; else autoGeneratedAudience"></app-inline-rename>
                <ng-template #autoGeneratedAudience>
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <h5 class="audience-title pl-8 mr-8">{{ audience.name }}</h5>
                        <mat-icon svgIcon="lock" matTooltip="{{ 'ENGAGE.AUDIENCE.TOOLTIPS.AUTO_GENERATED_AUDIENCE' | translate }}" matTooltipPosition="right"></mat-icon>
                    </div>
                </ng-template>
            </div>
            <ng-template #defaultAudienceTitle>
                <h5 *ngIf="audience" class="audience-title pl-8">{{ audience.name | audienceDisplayName }}</h5>
            </ng-template>
        </div>
        <div fxLayout="row" fxLayoutAlign="end flex-end" *ngIf="!audience?.isAutoGenerated">
            <app-white-button
                class="mr-8"
                *ngIf="!isAutomaticAudienceFlag"
                [label]="'ENGAGE.AUDIENCE.LABELS.ADD_SUBAUDIENCE'"
                [icon]="'add'"
                (onClick)="openDialogEngageNewSubAudience()"
            ></app-white-button>

            <app-white-button
                *ngIf="audience && audience.parent && !isAutomaticAudienceFlag"
                class="mr-8"
                [icon]="'drive_file_move'"
                [label]="'GENERAL.BUTTON.MOVE_TO'"
                (onClick)="openMoveToDialog(audience)"
            ></app-white-button>

            <app-white-button
                *ngIf="audience && audience.parent"
                [icon]="'delete'"
                [label]="'GENERAL.BUTTON.DELETE'"
                [showThreeDots]="isAutomaticAudienceFlag"
                (onClick)="openDialogEngageRemoveAudience()"
            ></app-white-button>
        </div>
    </mat-toolbar>
    <div class="audience-start">
        <ng-container *ngFor="let category of categories">
            <mat-card
                *ngIf="category.id !== 3 || totalTenantExperiencesCount >= 2"
                appearance="outlined"
                class="audience-start-card mb-24 p-20 mat-elevation-z0"
                [class.disabled]="isCategoryDisabled(category) || isCategoryDisabledForAutomaticAudience(category)"
                [routerLink]="isCategoryDisabled(category) || isCategoryDisabledForAutomaticAudience(category) ? null : category.url"
                [matTooltip]="'GENERAL.MESSAGE.NO_PERMISSION' | translate"
                [matTooltipDisabled]="!isCategoryDisabled(category)"
            >
                <mat-card-header class="audience-start-card-header">
                    <div mat-card-avatar class="audience-start-card-image" *ngIf="category.img; else categoryIcon" [style.background-image]="'url(' + category.img + ')'"></div>
                    <ng-template #categoryIcon>
                        <div mat-card-avatar class="audience-start-card-icon-container" [ngClass]="category.cls">
                            <div class="audience-start-card-icon"></div>
                        </div>
                    </ng-template>
                </mat-card-header>
                <mat-card-content class="audience-start-card-content">
                    <div>
                        <mat-card-title class="mb-4">{{ category.name | translate }}</mat-card-title>
                        <p class="mt-0 mb-4 text-xs" *ngIf="!isCategoryDisabledForAutomaticAudience(category)">{{ category.description | translate }}</p>
                        <p class="mt-0 mb-4 text-xs" *ngIf="isCategoryDisabledForAutomaticAudience(category)">
                            {{ 'ENGAGE.AUDIENCE.LABELS.WIDGET_CONTENT.DISABLED_AUTOMATIC' | translate }}
                        </p>
                        <p class="text-gray-400 text-xs mt-0" *ngIf="category.lastUpdate">{{ 'ENGAGE.LABELS.LAST_UPDATE' | translate }} {{ category.lastUpdate.fromNow() }}</p>
                        <p class="text-gray-400 text-xs mt-0" *ngIf="category.experiencesCount && !isCategoryDisabledForAutomaticAudience(category)">
                            {{ 'ENGAGE.AUDIENCE.LABELS.RELEVANT_EXPERIENCES_COUNT' | translate: { total: category.experiencesCount } }}
                        </p>
                        <p class="text-gray-400 text-xs mt-0" *ngIf="category.memberCount != null && audience">
                            {{ category.memberCount }} {{ 'ENGAGE.LABELS.MEMBERS' | translate }}
                        </p>
                    </div>
                    <div class="content-card-actions" *ngIf="!isCategoryDisabledForAutomaticAudience(category)">
                        <a [routerLink]="isCategoryDisabled(category) ? null : [category.url]" fxLayout="row" fxLayoutAlign="start center">{{ category.action | translate }}<mat-icon>arrow_right_alt</mat-icon> </a>
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </div>
</div>
